export default {
  mounted  (el, ops) {
    const key = ops.value
    const access = router.currentRoute?._value.meta?.access ?? []
    if (!access.includes(key)) {
      el.style.display = 'none'
    }
  },

}
